<mat-dialog-content class="app-dialog-container session-expiration-dialog">
    <div class="app-dialog-header">
        <div class="app-dialog-header-text">Session Expiration</div>
    </div>
    <div>
        <p>Your session is about to expire. Would you like to stay logged in?</p>
        <div class="session-expiration-dialog-countdown-ctr">
            <app-countdown (completed)="expire()"></app-countdown>
        </div>
        <div class="session-expiration-dialog-actions">
            <button class="button-flat" (click)="signOut()">NO</button>
            <button class="button-flat" (click)="refreshSession()">YES</button>
        </div>
    </div>
</mat-dialog-content>
